// extracted by mini-css-extract-plugin
export default {"wrapper":"image-placeholder_wrapper__LW-Qo","emptyBox":"image-placeholder_emptyBox__gxa+O"};